<script setup>
import {computed} from 'vue'
import {useRouter} from "vue-router";
import SiteFooter from "@/components/SiteFooter.vue";

const router = useRouter();

const transparentAppBar = true;

const showLogo = computed(() => {
  return router.currentRoute.value.name !== "about"
});

const showFooter = computed(() => {
  return router.currentRoute.value.name === "about"
});

const showAbout = computed(() => {
  return router.currentRoute.value.name !== "about"
});

</script>

<template>
  <v-layout>
    <v-app-bar :color="transparentAppBar? 'transparent': 'white'" :absolute="transparentAppBar" flat>
      <v-img class="ms-5" :src="require('@/assets/bip-logo.png')" max-width="32" v-if="showLogo"></v-img>
      <v-app-bar-title class="ms-5" v-if="showLogo">
        <router-link to="/"
                     :class="showLogo && transparentAppBar? 'text-white text-decoration-none' : 'text-black text-decoration-none'">
          Benchmark Instances Project
        </router-link>
      </v-app-bar-title>

      <router-link to="/" class="text-white text-decoration-none ms-5" v-if="!showLogo">
        <v-btn flat>
          <v-icon>mdi-chevron-left</v-icon>
          Go back
        </v-btn>
      </router-link>

      <v-spacer></v-spacer>

      <router-link to="/about" class="text-decoration-none ms-3" v-if="showAbout">
        <v-btn :color="transparentAppBar?'white' : 'black'">
          About
        </v-btn>
      </router-link>

    </v-app-bar>

    <v-main>
      <router-view/>
      <SiteFooter v-if="showFooter"/>
    </v-main>

  </v-layout>

</template>

<script>
export default {
  computed: {}
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  background: #fefefe;
}

</style>
